"use strict";
/**
 * Common types for the FirebaseV9 Web and Admin implementation.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldPlaceholder = void 0;
exports.partialToPatch = partialToPatch;
/**
 * My placeholder for Firestore FieldValue
 */
class FieldPlaceholder {
    constructor(mod, param) {
        this.mod = mod;
        this.param = param;
    }
    static increment(delta) {
        return new FieldPlaceholder('increment', delta);
    }
    static delete() {
        return new FieldPlaceholder('delete', 0);
    }
    isIncrement() {
        return this.mod === 'increment';
    }
    isDelete() {
        return this.mod === 'delete';
    }
    getParam() {
        return this.param;
    }
}
exports.FieldPlaceholder = FieldPlaceholder;
/**
 * Convert a partial document into a "patch" document (a single-level object with "." names)
 *
 * @param data
 * @returns
 */
function partialToPatch(ctx, data, convertFP) {
    const patch = {};
    // Allowed in inner fields, but not at top-level
    ctx.assertFalse(data instanceof FieldPlaceholder);
    doConvert('', data);
    return patch;
    /**
     * Convert given (sub-object) of DocType into flattened form.  Mutates the
     * containing scope 'patch' object.
     *
     * @param prefix path to to this object from root object
     * @param data object to flatten
     * @returns
     */
    function doConvert(prefix, data) {
        if (data === undefined || data === null) {
            return;
        }
        for (const [key, val] of Object.entries(data)) {
            const fqpath = glue(prefix, key);
            if (fqpath in patch) {
                throw ctx.newError(`Duplicate entry at "${String(fqpath)}": "${patch[fqpath]}" (and "${val}")`);
            }
            if (val === null || val === undefined) {
                //ctx.log('patch', fqpath, 'to', val);
                patch[fqpath] = val;
            }
            else if (typeof val === 'object') {
                if (Array.isArray(val)) {
                    // Use FieldValue array operations instead
                    throw ctx.newError(`Arrays do not lend themselves to Firestore "patches": ${String(fqpath)}`);
                }
                else if (val instanceof FieldPlaceholder || val.constructor.name === 'FieldPlaceholder') {
                    // 2023-01: Not sure why the 'val instance ...' check is insufficient.  They're
                    // definitely FieldPlaceholders, but the "wrong" ones.
                    const newfp = convertFP(val);
                    //ctx.log('patch', fqpath, 'FieldPlaceholder', val);
                    patch[fqpath] = newfp;
                }
                else {
                    doConvert(fqpath, val);
                }
            }
            else if ((typeof val === 'string') || (typeof val === 'number') || (typeof val === 'boolean')) {
                //ctx.log('patch', fqpath, 'scalar', val);
                patch[fqpath] = val;
            }
            else {
                throw ctx.newError(`Unexpected entry at "${String(fqpath)}": ${typeof val}: ${val}`);
            }
        }
    }
    /**
     * @returns string concatention of prefix (may be '') with given key in dotted-path form.
     */
    function glue(prefix, key) {
        if (key.includes('.')) {
            throw ctx.newError(`Input property names cannot include ".": ${key}`);
        }
        if (prefix === '') {
            return key;
        }
        return `${prefix}.${key}`;
    }
}
//# sourceMappingURL=FirebaseV9-CommonImpl.js.map